import React, { FC } from "react"
import { Link } from "gatsby"
import { DateTime } from "luxon"

import { PostTemplatePostFragmentFragment } from "@graphqlTypes"

import Avatar, { AVATAR_SIZES } from "@components/Avatar/Avatar"
import AvatarsRow from "@components/AvatarsRow/AvatarsRow"

import {
  PostAuthorsDIV,
} from "./PostAuthors.styles"

type PostAuthorsProps = {
  authors: PostTemplatePostFragmentFragment["authors"],
  date: PostTemplatePostFragmentFragment["date"],
}

const PostAuthors: FC<PostAuthorsProps> = ({ authors, date }) => (
  <PostAuthorsDIV className="PostAuthors font-family--mono">
    <AvatarsRow>
      {authors &&
        authors.map((author) =>
          author ? (
            <Link to={author.permalink}>
              <Avatar
                key={`PostHeroBlog_PostAuthors_${author.name}`}
                name={author.name || "Help Scout"}
                size={AVATAR_SIZES.S}
                image={author.image}
              />
            </Link>
          ) : null
        )}
    </AvatarsRow>
    {authors && (
      <span className="authors font-family--sans font-weight--medium type--text-S color--text-dark margin-bottom--0">
        Written By
        {" "}
        {authors.map((author, i) => (
          <>
            <Link to={author?.permalink || ""}>{author?.name}</Link>
            {i < authors.length - 2 && ", "}
            {i === authors.length - 2 && " & "}
          </>
        ))}
      </span>
    )}
    <span className="divider">•</span>
    <span className="font-family--sans type--text-S color--text-light margin-bottom--0 date">
      {DateTime.fromISO(date).toFormat("LLLL d, yyyy")}
    </span>
  </PostAuthorsDIV>
)

export default PostAuthors
